interface TutorialTitleProps {
	children?: any;
}

const TutorialTitle = ({ children }: TutorialTitleProps) => {
	return <strong className="text-[24px]">{children}</strong>;
};

export default TutorialTitle;
